import { Component, OnInit, Input, Output, EventEmitter  } from '@angular/core';
import { RepositoryService } from "../../shared/services/repository.service";
import { Risk } from "../../_interfaces/risk.model";
import { RiskUser } from './../../_interfaces/RiskUser.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-risk-list',
  templateUrl: './risk-list.component.html',
  styleUrls: ['./risk-list.component.css']
})
export class RiskListComponent implements OnInit {
  @Input() public headerText: string;
  @Input() public risks: Risk[];
  @Input() public riskType: number;
  @Output() messageToEmit = new EventEmitter<string>();
  public costBased: boolean;

  public user: RiskUser;

  constructor(
    private repository: RepositoryService,
    private router: Router
  ) { }

  ngOnInit() {
    this.user = this.repository.GetMyUser();
    this.repository.SetupPeople(); // Check if Risk Users are loaded - if not load them from Api
  }

  public getRiskDetails(riskId: number) {
    let riskDetailUrl: string = `/myrisks/details/${riskId}`;
    this.router.navigate([riskDetailUrl]);
  }

  public editRiskRecord(riskId: number) {
    let riskDetailUrl: string = `/myrisks/edit-risk/${riskId}`;
    this.router.navigate([riskDetailUrl]);
  }

  public archiveRiskRecord(riskId: number) {

    var result = confirm("Are you sure that you want to archive Risk " + riskId + " ?");
    if (!result) { return;}

    // Do a rest delete call and let the api set the archive date (rather than delete the record)
    //let apiAddress: string = `Risks` + riskId;
    //let apiUrl: string = `Risks?id=${riskId}`;
    const apiUrl: string = `Risks/${riskId}`;
    this.repository.delete(apiUrl)
      .subscribe(res => {
       
        this.messageToEmit.emit(`refresh`);
      });

  }
}
